import React, { useState } from "react";
import { CaretRight, List, X } from "@phosphor-icons/react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Occasions", to: "/#occasions" },
  { label: "Menu", to: "/#menu" },
  { label: "Gallery", to: "/#gallery" },
  { label: "Contact", to: "/#contact" },
];

export default function Header() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/70 border-b border-mg"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-10 h-16 sm:h-20">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
          <img
            src="/brand/moonglow-logo.png"
            alt="MoonGlow Screens · Private Theater"
            className="h-14 sm:h-16 md:h-20 w-auto select-none"
            draggable={false}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm text-white/80 hover:text-gold transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            data-testid="header-book-now-btn"
            onClick={() => navigate("/book")}
            className="btn-gold rounded-md px-4 sm:px-5 py-2 sm:py-2.5 text-xs sm:text-sm inline-flex items-center gap-2"
          >
            Book Now <CaretRight size={14} weight="bold" />
          </button>
          <button
            data-testid="mobile-menu-btn"
            className="md:hidden text-white/80 p-2"
            onClick={() => setOpen((o) => !o)}
            aria-label="menu"
          >
            {open ? <X size={20} /> : <List size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile nav */}
      {open && (
        <div className="md:hidden border-t border-mg bg-black/90 backdrop-blur-xl">
          <div className="flex flex-col px-6 py-4 gap-3">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="text-sm text-white/85 py-2 hover:text-gold"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
